import React from 'react'
import { Controller } from 'react-hook-form'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'
import { validateRequiredStringValue } from './_utils'
import { useUserFormContext } from '../utils/userFormContext'

const FirstName: React.FC = () => {
    const { state } = useUserFormContext()
    const { control } = useFormContextUser()

    return (
        <Controller
            control={control}
            name="firstName"
            rules={{
                required: 'Cette information est obligatoire et n’a pas été renseignée',
                validate: validateRequiredStringValue,
            }}
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="input"
                    label="Prénom d’exercice"
                    locked={state.rppsLocked}
                    required
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    placeholder="Prénom d’exercice"
                    {...field}
                    value={field?.value ?? ''}
                    disabled={state.rppsLocked}
                    dataCyScope="UserField"
                />
            )}
        />
    )
}

export default FirstName
